import { createBrowserHistory } from "history"

const history = createBrowserHistory()

export { history as default }



// WEBPACK FOOTER //
// ./assets/history.js